
import {LoadBackup} from "../actions/backup.action";
import {
  BackupListAction,
  LOAD_BACKUP_LIST,
  LOAD_BACKUP_LIST_FAIL,
  LOAD_BACKUP_LIST_SUCCESS, LoadBackupListFail,
  LoadBackupListSuccess
} from "../actions";

export interface IWebsiteBackupListState {
  websiteId: number;
  entities: {[id: string]: any};
  loading: boolean;
  loaded: boolean;
}

export interface IBackupListState {
  entities: {[websiteId: number]: IWebsiteBackupListState};
}

export const initialState: IBackupListState = {
  entities: {}
};

export function reducer(state: IBackupListState = initialState, action: BackupListAction): IBackupListState {
  let payload: any;

  switch (action.type) {

    case LOAD_BACKUP_LIST:
      payload = (<LoadBackup>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BACKUP_LIST_SUCCESS:
      payload = (<LoadBackupListSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_BACKUP_LIST_FAIL:
      payload = (<LoadBackupListFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
